import React from 'react';
import OrderCard from './src-components-AdvanceMessagingComponent-OrderList-OrderCard.js';
import ProductList from './src-components-AdvanceMessagingComponent-ProductList-ProductList.js';
import { util } from './src-utils-miaw-common.js';

const handleOrderSelect = (data) => {
  const orderData = data.messageData;
  const message = {
    id: util.generateUUID(),
    messageContent: /* @__PURE__ */ React.createElement(
      OrderCard,
      {
        orderDate: orderData.orderDate,
        orderId: orderData.orderId,
        orderItems: orderData.orderItems,
        orderNumber: orderData.orderNumber,
        displayPrice: orderData.displayPrice,
        sender: "user"
      }
    ),
    type: "user",
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    isMessageRead: false,
    showFeedback: false
    // senderDisplayName: '', // TODO
  };
  return { userMessage: message, query: `Order ID - ${orderData.orderId}` };
};
const handleProductSelect = (data) => {
  const productData = data.messageData;
  const message = {
    id: util.generateUUID(),
    messageContent: /* @__PURE__ */ React.createElement(ProductList, { items: productData.items, orderId: productData.orderId, sender: "user" }),
    type: "user",
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    isMessageRead: false,
    showFeedback: false
    // senderDisplayName: 'User'
  };
  return {
    userMessage: message,
    query: `Order ID - ${productData.orderId} and Product ID - [${productData.items.map((i) => i.itemId).join(",")}]`,
    selectedProductIds: productData.items.map((i) => i.itemId)
  };
};
const handleMessageWithDifferentQuery = (data) => {
  const message = {
    id: util.generateUUID(),
    messageContent: data.messageData?.messageText,
    type: "user",
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    isMessageRead: false,
    showFeedback: false
    // senderDisplayName: 'User'
  };
  return { userMessage: message, query: data.messageData?.query };
};
const handleTextMessage = (data) => {
  const message = {
    id: util.generateUUID(),
    messageContent: data.messageData,
    type: "user",
    timestamp: (/* @__PURE__ */ new Date()).getTime(),
    isMessageRead: false,
    showFeedback: false
    // senderDisplayName: 'User'
  };
  return { userMessage: message, query: data.messageData };
};

export { handleMessageWithDifferentQuery, handleOrderSelect, handleProductSelect, handleTextMessage };
//# sourceMappingURL=src-utils-chatbot-order-tracking-request-handlers.js.map
